import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import { AddCircleOutline, Delete } from '@mui/icons-material';
import { Grid, IconButton, Stack, TextField, Typography, styled } from '@mui/material';
import { SelectCreateWorkflowStatus } from '../SelectCreateWorkflowStatus';
import { WorkflowSubStatusRowRepeater } from '../WorkflowSubStatusRowRepeater/WorkflowSubStatusRowRepeater';
import LeadStore from '../../store/LeadStore';

const CustomButton = styled(Button)({
  backgroundColor: '#F07B0E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#f1785a',
  },
  width: 'fit-content',
});

export const WorkflowStatusRowRepeater = observer(
  ({ isError, setRowDetails, toggleSubStatusValidation, defaultRows }) => {
    const constructNewRow = (id) => {
      return {
        rowId: id,
        workflowStatus: null,
        workflowSubStatus: null,
        isNew: true,
      };
    };

    const constructDefaultRows = () => {
      const rowsLocal = [];
      defaultRows?.forEach((item, index) => {
        const subStatusRows = [];
        item.workflowSubStatusResponseDtos?.forEach((ss, ssIndex) => {
          subStatusRows.push({
            statusRowId: index + 1,
            rowId: ssIndex + 1,
            isDelete: ss.isDelete,
            workflowSubStatus: { id: ss.id, name: ss.name },
            isNew: false,
          });
        });
        rowsLocal.push({
          rowId: index + 1,
          isDelete: item.isDelete,
          workflowStatus: { id: item.id, name: item.name },
          workflowSubStatus: subStatusRows,
          isNew: false,
        });
      });

      return rowsLocal;
    };

    const [rows, setRows] = useState([]);
    const [actualRowsCount, setActualRowsCount] = useState(0);
    const [statusError, setStatusError] = useState(false);
    const [workflowStatusList, setWorkflowStatusList] = useState([]);

    const createNewRow = () => {
      const rowsCount = actualRowsCount + 1;
      setActualRowsCount(rowsCount);
      setRows([...rows, constructNewRow(rowsCount)]);
      setStatusError(false);
    };

    const handleDeleteRow = (id) => {
      setRows(rows.filter((item) => item.rowId.toString() !== id.toString()));
    };

    const handleSelectedWorkflowStatus = (workflowStatus, rowId) => {
      const selectedRowIndex = rows.findIndex((item) => item.rowId.toString() === rowId.toString());

      const rowsLocal = [...rows];
      rowsLocal[selectedRowIndex].workflowStatus = workflowStatus;

      setRows(rowsLocal);
    };

    useEffect(() => {
      const rowsLocal = [...rows];
      rowsLocal.forEach((item, index) => {
        item.sequence = index + 1;
      });
      setRowDetails(rowsLocal);
    }, [rows]);

    useEffect(() => {
      setStatusError(isError);
    }, [isError]);

    useEffect(() => {
      setRows(defaultRows?.length ? constructDefaultRows() : [constructNewRow(1)]);
      setActualRowsCount(defaultRows?.length ? defaultRows.length : 1);
    }, [defaultRows]);

    useEffect(() => {
      setWorkflowStatusList(LeadStore.workflowStatusList);
    }, [LeadStore.workflowStatusList]);

    const setSubStatusRowDetails = (statusRowId, subStatusRows) => {
      const selectedRowIndex = rows.findIndex((item) => item.rowId.toString() === statusRowId.toString());
      const rowsLocal = [...rows];
      rowsLocal[selectedRowIndex].workflowSubStatus = subStatusRows;

      setRowDetails(rowsLocal);
    };

    const toggleDeleteBtn = (item) => {
      if (item.isDelete) {
        return false;
      } else {
        return rows.length === 1 || !item.isNew;
      }
    };

    return (
      <>
        <Stack direction={'row'} sx={{ py: '5px' }}>
          <Typography sx={{ fontWeight: '600' }} component="p">
            Workflow Status mapping
          </Typography>
          <CustomButton
            sx={{ ml: 'auto' }}
            variant="contained"
            size="small"
            startIcon={<AddCircleOutline />}
            onClick={createNewRow}
          >
            Add
          </CustomButton>
        </Stack>
        <Stack direction={'column'} spacing={2}>
          {rows?.map((item, index) => {
            return (
              <Grid
                key={item.rowId}
                container
                flexDirection={'column'}
                sx={{ border: '1px solid #c7c7c782', borderRadius: '6px' }}
                justifyContent={'start'}
              >
                <Grid container flexDirection={'row'} gap={2} py={'15px'} px={'20px'} justifyContent={'start'}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {/* <SelectCreateWorkflowStatus label="Create/Select Status" dataList={workflowStatusList} selectedWorkflowStatusList={rows.map(item => item.workflowStatus).filter(item => item !== null)} id={item.rowId} handleSelectedWorkflowStatus={workflowStatus => handleSelectedWorkflowStatus(workflowStatus, item.rowId)}></SelectCreateWorkflowStatus> */}
                    <TextField
                      label="workflowStatus"
                      id="workflow-status"
                      size="small"
                      name="workflowStatus"
                      value={item.workflowStatus?.name ?? ''}
                      fullWidth
                      onChange={(e) => {
                        const status = item.isNew
                          ? { id: null, name: e.target.value }
                          : {
                              id: item.workflowStatus.id,
                              name: e.target.value,
                            };
                        handleSelectedWorkflowStatus(status, item.rowId);
                      }}
                      sx={{ fontSize: '12px' }}
                    />
                  </Grid>
                  <Grid item xs={10} sm={4} md={4} lg={2}>
                    <TextField
                      name="sequence"
                      label="Sequence"
                      size="small"
                      value={index + 1}
                      fullWidth
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={1} sm={1} md={1} lg={1}>
                    <IconButton
                      disabled={toggleDeleteBtn(item)}
                      aria-label="delete"
                      sx={{ alignSelf: 'baseline' }}
                      onClick={() => handleDeleteRow(item.rowId)}
                      color="error"
                    >
                      <Delete />
                    </IconButton>
                  </Grid>
                </Grid>
                <Grid py={'15px'} px={'20px'}>
                  <WorkflowSubStatusRowRepeater
                    statusRowId={item.rowId}
                    setSubStatusRowDetails={setSubStatusRowDetails}
                    toggleSubStatusValidation={toggleSubStatusValidation}
                    defaultRows={item.workflowSubStatus}
                  ></WorkflowSubStatusRowRepeater>
                </Grid>
              </Grid>
            );
          })}
        </Stack>
        <div
          id="workflowStatus-error-message"
          className={isError ? '' : 'lm-d-none'}
          style={{ marginTop: '10px', fontSize: '12px', color: '#ff0000' }}
        >
          {rows.length > 1
            ? 'Please Create a workflow OR delete if not required'
            : 'Please create atleast one workflow status'}
        </div>
      </>
    );
  }
);
